import { render, staticRenderFns } from "./OnlineClick.vue?vue&type=template&id=0fd4ff24&scoped=true"
import script from "./OnlineClick.vue?vue&type=script&lang=js"
export * from "./OnlineClick.vue?vue&type=script&lang=js"
import style0 from "./OnlineClick.vue?vue&type=style&index=0&id=0fd4ff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4ff24",
  null
  
)

export default component.exports